import React from 'react';

import { PartnerBadge } from '@sravni/react-ugc/lib/PartnerBadge';

import styles from './header-logo.module.scss';
import DefaultLogo from './images/DefaultLogo.svg';

interface IOrganizationLogoProps {
  logoSrc: string;
  isPartner: boolean;
  productLogo?: string;
}

export const OrganizationLogo: React.FC<IOrganizationLogoProps> = ({
  logoSrc = DefaultLogo,
  isPartner,
  productLogo,
}) => {
  if (!logoSrc) return null;

  if (productLogo) {
    return (
      <div className={styles.productLogo}>
        <img src={productLogo} />
      </div>
    );
  }

  return (
    <div>
      {isPartner ? (
        <PartnerBadge>
          <img className={styles.logo} src={logoSrc} />
        </PartnerBadge>
      ) : (
        <img className={styles.logo} src={logoSrc} />
      )}
    </div>
  );
};
